import axios from './axios'



// 盘点列表
export function queryDifferencesPage(data){
    return axios.post(`commodity/queryDifferencesPage`,data)
}
